import Icons from "../../../../resources/icons/Icons";
import classes from "./RateCard.module.css";

import CustomMenu from "../../../../components/UI/Menus/CustomMenu/CustomMenu"; 
import { MenuItemEntity } from "../../../../entities/UIEntities/MenuItem"; 
import { MENU_ITEMS } from "../../../../enums/Enums";

export const RateCard = (props) => {

  const deleteRate = () => {
    props.handleDeleteRate(props.item?.id);
  };

  const menuItems = [
    new MenuItemEntity(
      MENU_ITEMS.DELETE,
      deleteRate,
      true,
      Icons.DELETE_ITEM,
      false,
      props
    )];

  return (
    <div className={classes.rateContainer}>
      <div className={classes.leftRate}>
        <img src={Icons.RATE_LIST} />
        <div className={classes.durationContainer}>
          <span className={classes.duration}>
            {`${props.item?.duration} ${props.item?.chargeBy}`}
          </span>
          <span className={classes.period}>Period: {props.item?.period}</span>
        </div>
        
      </div>
      <div className={classes.rightRate}>
        <div className={classes.amount}>{props.item?.rateAmount} {props.currency}</div>
        <div><CustomMenu menuItems={menuItems}></CustomMenu></div>
      </div>
      
      
      {/* <div><CustomMenu menuItems={menuItems}></CustomMenu></div> */}
    </div>
  );
};

export default RateCard;
